/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ApplicationState = {
    Submitted: 'SUBMITTED',
    Accepted: 'ACCEPTED',
    Refused: 'REFUSED',
    Done: 'DONE'
} as const;
export type ApplicationState = typeof ApplicationState[keyof typeof ApplicationState];


export function instanceOfApplicationState(value: any): boolean {
    for (const key in ApplicationState) {
        if (Object.prototype.hasOwnProperty.call(ApplicationState, key)) {
            // @ts-ignore
            if (ApplicationState[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationStateFromJSON(json: any): ApplicationState {
    return ApplicationStateFromJSONTyped(json, false);
}

export function ApplicationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationState {
    return json as ApplicationState;
}

export function ApplicationStateToJSON(value?: ApplicationState | null): any {
    return value as any;
}

